(() => {
  const isMobile = () => window.matchMedia("(max-width: 991px)").matches;

  /* Returns null (not `document`) when the opener is a plain dropdown with no push menu —
     `document` has no classList, so the old fallback threw inside activateScreen(). */
  function closestWrapper(el) {
    return (
      el.closest(".--mega-dropdown-wrapper") ||
      el.closest(".dropdown-component_wrapper") ||
      null
    );
  }

  function getContainer(wrapper) {
    return wrapper.querySelector(".container") || wrapper;
  }

  function syncHeight(wrapper) {
    if (!wrapper) return;

    const container = getContainer(wrapper);
    const active = wrapper.querySelector(".mm-screen.is-active") || wrapper.querySelector(".mm-screen--root");
    if (!active) return;

    // Ensure container has enough height for absolute-positioned screens
    // Use scrollHeight so it includes inner content.
    const h = active.scrollHeight;

    // Set minHeight so it doesn't collapse; allow max-height to cap scrolling
    container.style.minHeight = h + "px";
  }

  function activateScreen(wrapper, key, direction = "forward") {
    if (!wrapper || !wrapper.classList) return;

    wrapper.classList.toggle("mm-dir-back", direction === "back");

    const screens = wrapper.querySelectorAll(".mm-screen");
    screens.forEach((s) => s.classList.remove("is-active"));

    const target = wrapper.querySelector(
      `.mm-screen[data-mm-screen="${CSS.escape(key)}"]`
    );

    if (target) {
      target.classList.add("is-active");
      // next tick to allow layout to update
      requestAnimationFrame(() => syncHeight(wrapper));
    }
  }

  function openRootFromOpener(opener) {
    const wrapper = closestWrapper(opener);
    if (!wrapper) return;
    wrapper.__mmStack = [];
    activateScreen(wrapper, "root", "forward");
  }

  /* Back used to jump straight to "root", which only works for a 2-level menu.
     The mega menu is now push-only at every depth, so we keep a real back-stack.
     Falls back to data-mm-parent, then to "root", so older markup still behaves. */
  function goBack(wrapper) {
    const stack = wrapper.__mmStack || [];
    stack.pop(); // drop the screen we are leaving
    let key = stack[stack.length - 1];

    if (!key) {
      const active = wrapper.querySelector(".mm-screen.is-active");
      key = (active && active.getAttribute("data-mm-parent")) || "root";
    }
    if (key === "root") wrapper.__mmStack = [];
    activateScreen(wrapper, key, "back");
  }

  function setup(wrapper) {
    if (!wrapper || wrapper.__mmBound) return;
    if (!wrapper.querySelector(".mm-screen")) return; // only bind where push menu exists
    wrapper.__mmBound = true;

    // Initial height sync (in case root is already active)
    requestAnimationFrame(() => syncHeight(wrapper));

    wrapper.addEventListener("click", (e) => {
      if (!isMobile()) return;

      const nextBtn = e.target.closest("[data-mm-next]");
      if (nextBtn) {
        const key = nextBtn.getAttribute("data-mm-next");
        if (!wrapper.__mmStack || !wrapper.__mmStack.length) wrapper.__mmStack = ["root"];
        wrapper.__mmStack.push(key);
        activateScreen(wrapper, key, "forward");
        return;
      }

      const backBtn = e.target.closest("[data-mm-back]");
      if (backBtn) {
        goBack(wrapper);
        return;
      }

      const closeBtn = e.target.closest("[data-mm-close]");
      if (closeBtn) {
        wrapper.classList.remove("mm-dir-back");
        wrapper.__mmStack = [];

        const dropdown = wrapper.closest("dropdown-component");
        const opener = dropdown?.querySelector(".dropdown-component_opener");
        if (opener) opener.click();
        return;
      }

      const accBtn = e.target.closest("[data-mm-acc-toggle]");
      if (accBtn) {
        const key = accBtn.getAttribute("data-mm-acc-toggle");
        const panel = wrapper.querySelector(
          `[data-mm-acc-panel="${CSS.escape(key)}"]`
        );
        if (!panel) return;

        const isOpen = accBtn.getAttribute("aria-expanded") === "true";
        accBtn.setAttribute("aria-expanded", String(!isOpen));
        panel.hidden = isOpen;

        requestAnimationFrame(() => syncHeight(wrapper));
        return;
      }
    });

    // Ensure root screen activates & height is synced when dropdown opens
    const dropdown = wrapper.closest("dropdown-component");
    const opener =
      dropdown?.querySelector("[data-mm-open-root]") ||
      dropdown?.querySelector(".dropdown-component_opener");

    if (opener) {
      opener.addEventListener(
        "click",
        () => {
          if (!isMobile()) return;
          setTimeout(() => {
            openRootFromOpener(opener);
            syncHeight(wrapper);
          }, 0);
        },
        { passive: true }
      );
    }
  }

  function init() {
    if (!isMobile()) return;
    document.querySelectorAll(".--mega-dropdown-wrapper").forEach(setup);
  }

  document.addEventListener("DOMContentLoaded", init);
  window.addEventListener("resize", () => {
    init();
    // resync heights on resize
    document.querySelectorAll(".--mega-dropdown-wrapper").forEach((w) => {
      if (w.__mmBound) syncHeight(w);
    });
  });
})();

(function () {
  const mq = window.matchMedia("(max-width: 991px)");

  function getDrawerScroller(btn) {
    // Your detected scroller (stable by id prefix, safer than full id)
    return (
      document.querySelector('[id$="__header-modal-menu-drawer"].modal-component_wrapper') ||
      document.querySelector('.modal-component_wrapper')
    );
  }

  document.addEventListener(
    "click",
    function (e) {
      if (!mq.matches) return;

      const btn = e.target.closest(".main-navigation_dropdown-opener");
      if (!btn) return;

      // run only when opening (not when closing)
      if (btn.getAttribute("aria-expanded") !== "false") return;

      const li = btn.closest(".main-navigation_item");
      const scroller = getDrawerScroller(btn);
      if (!li || !scroller) return;

      // wait for open + layout settle
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          const scRect = scroller.getBoundingClientRect();
          const liRect = li.getBoundingClientRect();
          const delta = liRect.top - scRect.top;

          scroller.scrollTo({
            top: scroller.scrollTop + delta,
            behavior: "smooth",
          });
        })
      );
    },
    true
  );
})();


